import React, {Component} from 'react';
import {gpn} from "../../GPN"
import Back from "../../sections/Back";
import req from "../../req";
import Button from "../../sections/MUI/Button";
import Field from "../../sections/MUI/Field";
import Select from "../../sections/MUI/Select";
import {toast} from "react-toastify";
import Modal from "../../sections/MUI/Modal";
import config from "../../config";
import axios from "axios";
import FileDownload from "js-file-download";
import File from "../../sections/MUI/File";

class User extends Component {

    state = {
        facilities: [],
        userFacilities: [],
        services: [],
        userServices: [],

        id: this.props.params.id,
        fullName: "",
        nationalCode: "",
        fatherName: "",
        birthDate: "",
        shenasnameh: "",
        postalCode: "",
        sokoonat: "",
        address: "",
        addressEstelam: "",
        phone: "",
        elatMorajeeh: "",
        nahveAshnayei: "",
        signature: "",
        validation: null,
        createdAt: "",

        step: "",

        validationFile: null,

        isAthVerified: false,

        estelamIsPaid: false,
        estelam: [],

        editMode: false,
        modalSelectFacilities: false,
        modalSelectServices: false,
        modalDelete: false,
        modalUploadValidation: false
    };

    componentDidMount() {
        config.scrollTop();
        this.getUser();
        setTimeout(() => {
            this.getFacilities();
        }, 800);
        setTimeout(() => {
            this.getUserFacilities();
        }, 1600);

        setTimeout(() => {
            this.getServices();
        }, 2400);

        setTimeout(() => {
            this.getUserServices();
        }, 3200);
    }

    getUserServices() {
        let {id} = this.state;
        req.get(`/user/services?id=${id}`)
            .then(r => {
                this.setState({
                    userServices: r
                });
            });
    }

    getServices() {
        req.get(`/service`)
            .then(r => {
                r = r ? r : [];
                this.setState({services: r});
            });
    }

    getUserFacilities() {
        let {id} = this.state;
        req.get(`/user/facilities?id=${id}`)
            .then(r => {
                this.setState({
                    ...this.state,
                    userFacilities: r
                });
            });
    }

    getFacilities() {
        req.get(`/facilities`)
            .then(r => {
                r = r ? r : [];
                this.setState({facilities: r});
            });
    }

    getUser() {
        let {id} = this.state;
        req.get(`/user?id=${id}`)
            .then(r => {
                this.setState({...r});
            });
    }

    deleteUser() {
        let {id} = this.state;
        toast.info("در حال حذف ...");
        this.setState({modalDelete: false});
        req.delete(`/user?id=${id}`)
            .then(r => {
                if (r) {
                    toast.success("با موفقیت حذف شد.");
                    this.props.navigate(-1);
                }
            });
    }

    handleEdit() {
        let {
            id,
            fullName, nationalCode,
            fatherName, birthDate,
            shenasnameh, postalCode,
            sokoonat, address,
            elatMorajeeh,
            nahveAshnayei
        } = this.state;
        toast.info("در حال ذخیره کردن ...");
        req.put(`/user`, {
            id,
            fullName, nationalCode,
            fatherName, birthDate,
            shenasnameh, postalCode,
            sokoonat, address,
            elatMorajeeh,
            nahveAshnayei
        })
            .then(r => {
                if (r) {
                    toast.success("با موفقیت ذخیره شد.");
                    this.getUser();
                }
            });
    }

    submitUserFacilities() {
        let {userFacilities, id} = this.state;
        let user = id;
        if (userFacilities.length > 0) {
            toast.info("درحال ثبت ...");
            req.post("/user/facilities", {
                user,
                facilities: userFacilities
            })
                .then(r => {
                    toast.success("با موفقیت ذخیره شد.");
                    this.setState({modalSelectFacilities: false});
                    this.getUserFacilities();
                });
        } else {
            toast.error("طرح تسهلات انتخاب نشده است!");
        }
    }

    submitUserServices() {
        let {userServices, id} = this.state;
        let user = id;
        if (userServices.length > 0) {
            toast.info("درحال ثبت ...");
            req.post("/user/services", {
                user,
                services: userServices
            })
                .then(r => {
                    toast.success("با موفقیت ذخیره شد.");
                    this.setState({modalSelectServices: false});
                    this.getUserServices();
                });
        } else {
            toast.error("خدمات انتخاب نشده است!");
        }
    }

    downloadValidation() {
        let {validation} = this.state;

        if (validation) {
            axios.post(`${config.api}/admin/user/validation/download`, JSON.stringify({
                file: validation
            }), {
                headers: {
                    "content-type": "application/json",
                    "authorization": config.token
                },
                responseType: 'blob'
            })
                .then(r => {
                    FileDownload(r.data, `${this.state.phone}.pdf`);
                })
                .catch(err => {
                    console.error(err);
                });

        }
    }

    deleteValidation() {
        let {validation} = this.state;
        toast.info("در حال حذف ...");
        req.delete(`/user/validation?file=${validation}`)
            .then(r => {
                toast.success("با موفقیت حذف شد.");
                this.getUser();
            })
            .catch(err => {
                config.handleError(err);
            });

    }

    uploadValidation() {
        let {id, validationFile} = this.state;

        if (validationFile) {
            let params = new FormData();
            params.append("id", id);
            params.append("file", validationFile);

            this.setState({
                modalUploadValidation: false
            });
            toast.info("در حال آپلود ...");

            axios.post(`https://api.ghestitak.ir/admin/user/validation`, params, {
                header: {
                    'content-type': 'multipart/form-data',
                    "authorization": config.token
                },
                headers: {
                    'content-type': 'multipart/form-data',
                    "authorization": config.token
                }
            })
                .then(r => {
                    toast.success("فایل اعتبارسنجی با موفقیت آپلود شد.");
                    this.getUser();
                })
                .catch(err => {
                    config.handleError(err);
                });
        } else {
            toast.error("فایلی انتخاب نشده است!");
        }
    }

    handleDeleteAuth() {
        toast.info("در حال حذف احراز هویت ...", {autoClose: 1400});
        req.delete(`/user/auth?id=${this.state.id}`)
            .then(r => {
                if (r) {
                    toast.success("با موفقیت حذف شد.", {autoClose: 2000});
                    this.getUser();
                }
            });
    }

    handleAthExempt() {
        toast.info("در حال معاف کردن ...", {autoClose: 1400});
        req.put("/user/auth", {id: this.state.id})
            .then(r => {
                if (r) {
                    toast.success("معاف شد.", {autoClose: 2000});
                    this.getUser();
                }
            });
    }

    handleSetEstelamPayment() {
        let {id, estelamIsPaid} = this.state;
        req.put("/user/estelam/is-paid", {
            estelamIsPaid: !estelamIsPaid,
            id
        })
            .then(r => {
                if (r) {
                    toast.info("وضعیت پرداخت هزینه استعلام با موفقیت ویرایش شد (کارتخوان).");
                    this.setState({estelamIsPaid: !estelamIsPaid});
                    this.getUser();
                }
            });
    }

    render() {
        let {
            id,
            fullName, nationalCode,
            fatherName, birthDate,
            shenasnameh,
            job,
            postalCode,
            sokoonat, address,
            addressEstelam,
            phone, elatMorajeeh,
            nahveAshnayei, signature,
            createdAt,
            step,
            editMode,
            modalDelete,
            modalUploadValidation,
            validation,
            validationFile,
            isAthVerified,
            estelamIsPaid,
            estelam
        } = this.state;

        return (
            <div className="user">
                <Modal display={modalUploadValidation} title="آپلود اعتبارسنجی"
                       onCloseClick={() => this.setState({modalUploadValidation: false})}>
                    <File name="validationFile"
                          value={validationFile}
                          accept={".pdf"}
                          onChange={(name, value) => this.setState({[name]: value})}
                          multiple={false}/>

                    <div className="row justify-content-center">
                        <div className="col-md-5">
                            <Button icon="check" onClick={() => this.uploadValidation()}>آپلود فایل</Button>
                        </div>
                    </div>
                </Modal>
                {this.modalSF()}
                {this.modalServices()}
                <Modal display={modalDelete}
                       title={"حذف " + fullName}
                       onCloseClick={() => this.setState({modalDelete: false})}>
                    <p style={{color: "#ab1717", textAlign: "center"}}>برای حذف این کاربر اطمینان دارید؟</p>

                    <div className="row">
                        <div className="col-8">
                            <Button backgroundColor="#656565"
                                    onClick={() => this.setState({modalDelete: false})}>خیر، حذف نشود</Button>
                        </div>
                        <div className="col-4">
                            <Button backgroundColor="#ab1717"
                                    onClick={() => this.deleteUser()}>بله، حذف شود</Button>
                        </div>
                    </div>
                </Modal>
                <Back {...this.props}/>

                <div className="row justify-content-center">
                    <div className="col-3">
                        <Button icon="edit"
                                onClick={() => this.setState({editMode: !editMode})}>ویرایش&nbsp;({editMode ? "فعال" : "غیرفعال"})</Button>
                    </div>
                    <div className="col-4">
                        <Button icon="bars"
                                backgroundColor="#1976D2"
                                onClick={() => this.setState({modalSelectServices: true})}>انتخاب خدمات برای
                            کاربر</Button>
                    </div>
                    <div className="col-5">
                        <Button icon="bars"
                                backgroundColor="#1976D2"
                                onClick={() => this.setState({modalSelectFacilities: true})}>انتخاب طرح برای
                            کاربر</Button>
                    </div>
                    <div className="col-3">
                        <Button icon="bars"
                                backgroundColor="#FF3F33"
                                onClick={() => this.setState({modalUploadValidation: true})}>آپلود فایل
                            اعتبارسنجی</Button>
                    </div>
                    <div className="col-6">
                        {
                            estelamIsPaid ?
                                <Button
                                    backgroundColor="#a81a1a"
                                    onDoubleClick={() => this.handleSetEstelamPayment()}
                                    icon="close">حذف معافیت هزینه استعلام (2 کلیک)</Button>
                                :
                                <Button
                                    backgroundColor="#1a52a8"
                                    onDoubleClick={() => this.handleSetEstelamPayment()}
                                    icon="check">معاف کردن از هزینه استعلام (2 کلیک)</Button>
                        }
                    </div>
                </div>

                <br/>
                <h1>{phone}</h1>
                <h2>{id}</h2>
                <br/>
                <div className="video-auth">
                    <p className="title">وضعیت احراز هویت ویدیو:</p>
                    {
                        isAthVerified ?
                            <>
                                <div className="user-is-verified">کاربر احراز هویت کرده است&nbsp;<span
                                    className="delete"
                                    onDoubleClick={() => this.handleDeleteAuth()}>حذف احراز هویت (دوبار کلیک)</span>
                                </div>
                            </>
                            :
                            <div className="user-is-not-verified">
                                <div className="text">
                                    کاربر احراز هویت نکرده است
                                </div>
                                <div className="button">
                                    <span className="exempt"
                                          onClick={() => this.handleAthExempt()}>معاف از احراز هویت</span>
                                </div>
                            </div>
                    }
                </div>
                <br/>
                {
                    !editMode ?
                        <>
                            <p><span>نام و نام خانوادگی:</span><span>{fullName}</span></p>
                            <p><span>کد ملی:</span><span>{nationalCode}</span></p>
                            <p><span>نام پدر:</span><span>{fatherName}</span></p>
                            <p><span>تاریخ تولد:</span><span>{birthDate}</span></p>
                            <p><span>شماره شناسنامه:</span><span>{shenasnameh}</span></p>
                            <p><span>شغل:</span><span>{job}</span></p>
                            <p><span>کد پستی:</span><span>{postalCode}</span></p>
                            <p><span>وضعیت سکونت:</span><span>{sokoonat}</span></p>
                            <p><span>آدرس:</span><span>{address}</span></p>
                            <p><span>آدرس استعلام شده از پست:</span><span>{addressEstelam}</span></p>
                            <p><span>علت مراجعه:</span><span>{elatMorajeeh}</span></p>
                            <p><span>نحوه آشنایی با شرکت:</span><span>{nahveAshnayei}</span></p>
                            <p><span>تاریخ ثبت نام:</span><span>{createdAt}</span></p>
                        </>
                        :
                        <>
                            <Field name="fullName"
                                   value={fullName}
                                   label="نام و نام خانوادگی"
                                   maxLength={300}
                                   onChange={(name, value) => this.setState({[name]: value})}/>
                            <Field name="nationalCode"
                                   value={nationalCode}
                                   label="کد ملی"
                                   type="number"
                                   style={{direction: "ltr"}}
                                   maxLength={10}
                                   onChange={(name, value) => this.setState({[name]: value})}/>
                            <Field name="fatherName"
                                   value={fatherName}
                                   label="نام پدر"
                                   maxLength={300}
                                   onChange={(name, value) => this.setState({[name]: value})}/>
                            <Field name="birthDate"
                                   value={birthDate}
                                   label="تاریخ تولد"
                                   style={{direction: "ltr"}}
                                   maxLength={10}
                                   onChange={(name, value) => this.setState({[name]: value})}/>
                            <Field name="shenasnameh"
                                   type="number"
                                   value={shenasnameh}
                                   label="شماره شناسنامه"
                                   style={{direction: "ltr"}}
                                   maxLength={10}
                                   onChange={(name, value) => this.setState({[name]: value})}/>
                            <Field name="job"
                                   value={job}
                                   label="شغل"
                                   maxLength={250}
                                   onChange={(name, value) => this.setState({[name]: value})}/>
                            <Field name="postalCode"
                                   type="number"
                                   value={postalCode}
                                   label="کد پستی"
                                   style={{direction: "ltr"}}
                                   maxLength={10}
                                   onChange={(name, value) => this.setState({[name]: value})}/>
                            <Select name="sokoonat"
                                    value={sokoonat}
                                    label="وضعیت سکونت"
                                    onChange={(name, value) => this.setState({[name]: value})}
                                    options={[
                                        {t: "مالک", v: "مالک"},
                                        {t: "مستأجر", v: "مستأجر"}
                                    ]}/>
                            <Field name="address"
                                   type="textarea"
                                   value={address}
                                   row={3}
                                   label="آدرس"
                                   maxLength={2000}
                                   onChange={(name, value) => this.setState({[name]: value})}/>
                            <Field name="elatMorajeeh"
                                   value={elatMorajeeh}
                                   label="علت مراجعه"
                                   maxLength={1000}
                                   onChange={(name, value) => this.setState({[name]: value})}/>
                            <Field name="nahveAshnayei"
                                   value={nahveAshnayei}
                                   label="نحوه آشنایی با شرکت"
                                   maxLength={1000}
                                   onChange={(name, value) => this.setState({[name]: value})}/>

                        </>
                }
                <div className="image">
                    <img src={signature} alt="امضاء"/>
                </div>

                <br/>

                {
                    editMode ?
                        <div className="row justify-content-center">
                            <div className="col-md-4">
                                <Button icon="check" onClick={() => this.handleEdit()}>ذخیره
                                    مشخصات</Button>
                            </div>
                        </div>
                        : null
                }

                <div className="estelam-info">
                    <h2>نتیجه استعلام</h2>
                    <div className="list">
                        {
                            estelam?.length > 0 ?
                                estelam?.map((it, i) =>
                                    <article key={"est" + i}>
                                        {Object.keys(it).map((key, i2) => (
                                            <p key={"est" + i + "p" + i2}>
                                                <span>{config.getEstelamKeyName(key)}:</span>
                                                {
                                                    key === "db" ?
                                                        <span
                                                            style={{color: config.getEstelamColor(key)}}>{config.decodeBase64(it[key])}</span>
                                                        : <span
                                                            style={{color: config.getEstelamColor(key)}}>{it[key]}</span>
                                                }
                                            </p>
                                        ))}
                                    </article>
                                )
                                :
                                <div
                                    style={{
                                        textAlign: "center",
                                        padding: "26px 8px",
                                        fontSize: "14pt",
                                        color: "#656565"
                                    }}>اطلاعاتی یافت نشد!</div>
                        }
                    </div>
                </div>
                <div className="row justify-content-between">
                    <div className="col-md-4">
                        <Button icon="print"
                                onClick={() => this.props.navigate(`/user/contract/${id}`)}>پرینت
                            قرارداد</Button>
                    </div>
                    {
                        validation ? validation !== "" ?
                            <>
                                <div className="col-md-4">
                                    <Button icon="download"
                                            onClick={() => this.downloadValidation()}>دانلود فایل
                                        اعتبارسنجی</Button>
                                </div>
                                <div className="col-4">
                                    <Button icon="trash" backgroundColor="#B71C1C"
                                            onDoubleClick={() => this.deleteValidation()}>حذف
                                        اعتبارسنجی</Button>
                                </div>
                            </>

                            : null : null
                    }


                </div>

                <br/><br/><br/><br/>

                <div className="row">
                    <div className="col-4">
                        <Button icon="trash" backgroundColor="#B71C1C"
                                onDoubleClick={() => this.setState({modalDelete: true})}>حذف
                            کاربر</Button>
                    </div>
                </div>
            </div>
        );
    }

    handleServiceClick(id = "") {
        let {userServices} = this.state;

        let index = -1;
        userServices.map((us, i) => {
            if (us.toString() === id.toString()) {
                index = i;
            }
        });

        if (index === -1) {
            userServices.push(id.toString());
        } else {
            userServices.splice(index, 1);
        }
        this.setState({
            userServices
        });
    }

    serviceItemIsActive(id) {
        let {userServices} = this.state;
        let finalServices = []
        userServices.map(us => {
            finalServices.push(us.toString());
        });
        return finalServices.includes(id.toString());
    }

    modalServices() {
        let {services, modalSelectServices} = this.state;
        if (!modalSelectServices) {
            return null;
        }
        return (
            <Modal display={modalSelectServices}
                   title="ثبت خدمات برای کاربر"
                   onCloseClick={() => this.setState({modalSelectServices: false})}>
                <div className="modal-select-facilities">
                    {
                        services.map((s, i) =>
                            <article key={"fac" + i}
                                     className={this.serviceItemIsActive(s.id) ? "active" : ""}
                                     onClick={() => this.handleServiceClick(s.id)}>
                                <p className="title"><
                                    span>{s.title}</span>
                                    <span>{s.price}&nbsp;تومان</span>
                                </p>
                            </article>
                        )
                    }

                    <br/>
                    <div className="row justify-content-center">
                        <Button icon="check"
                                onClick={() => this.submitUserServices()}>ثبت خدمات</Button>
                    </div>
                </div>
            </Modal>
        )
    }

    handleFacilitiesClick(id = "") {
        let {userFacilities} = this.state;

        let index = -1;
        userFacilities.map((uf, i) => {
            if (uf.toString() === id.toString()) {
                index = i;
            }
        });

        if (index === -1) {
            userFacilities.push(id.toString());
        } else {
            userFacilities.splice(index, 1);
        }
        this.setState({
            userFacilities
        });
    }

    facilitiesItemIsActive(id) {
        let {userFacilities} = this.state;
        let finalFacilities = []
        userFacilities.map(uf => {
            finalFacilities.push(uf.toString());
        });
        return finalFacilities.includes(id.toString());
    }


    modalSF() {
        let {facilities, modalSelectFacilities} = this.state;

        if (!modalSelectFacilities) {
            return null;
        }

        return (
            <Modal display={modalSelectFacilities}
                   title="ثبت طرح برای کاربر"
                   onCloseClick={() => this.setState({modalSelectFacilities: false})}>
                <div className="modal-select-facilities">
                    {
                        facilities.map((f, i) =>
                            <article key={"fac" + i}
                                     className={this.facilitiesItemIsActive(f._id) ? "active" : ""}
                                     onClick={() => this.handleFacilitiesClick(f._id)}>
                                <p className="title">
                                    <span>{f.title}</span><span>({config.priceFormatter(f.price)}&nbsp;تومان)</span></p>
                                <p>
                                    <span>هزینه ثبت نام:</span><span>{config.priceFormatter(f.registerPrice)}&nbsp;تومان</span>
                                </p>
                            </article>
                        )
                    }

                    <br/>
                    <div className="row justify-content-center">
                        <Button icon="check"
                                onClick={() => this.submitUserFacilities()}>ثبت طرح (ها)</Button>
                    </div>
                </div>
            </Modal>
        )
    }
}

export default gpn(User);